import { FC } from 'react';

const SideBarLinkWrapper: FC = ({ children }) => {
  return <div className="sidebar-link-wrapper py-5">{children}</div>;
};

export default SideBarLinkWrapper;
